import axios from "axios";

export const uploadCSV = async (payload, token) => {
  const { portfolio, file } = payload;
  const formData = new FormData();
  formData.append("portfolio", JSON.stringify(portfolio));
  formData.append("file", file);
  try {
    const res = await axios.post("xbucket/import-mongo/", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const fetchPortfolioMappers = async (id, token) => {
  try {
    const res = await axios.get(`portfolio/mapheaders/${id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const updatePortfolioMapHeaders = async (id, payload, token) => {
  try {
    const res = await axios.post(`portfolio/mapheaders/${id}/`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res?.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
      error.message ||
      "Failed to update headers"
    );
  }
};

export const fetchPortfolioMaster = async (id, token) => {
  try {
    const res = await axios.get(`portfolio/master-header/${id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const updatePortfolioMasterHeaders = async (id, payload, token) => {
  try {
    const res = await axios.patch(`portfolio/master-header/${id}/`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};


export const unarchivePortfolio = async (id, token) => {
  try {
    const res = await axios.post(`portfolio/portfolio/${id}/unarchive/`, {}, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
      error.message ||
      "Failed to update headers"
    );
  }
};

export const getPortfolioLink = async (token, id, url) => {
  try {
    const res = await axios.get(`${url}/${id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (error) {

  }
}
export const downloadAllFiles = async (token, id) => {
  try {
    const res = await axios.get(`portfolio/portfolio-files-zip-download/${id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (error) {

  }
}


export const deletePortfolioFile = async (payload, token) => {
  const { portfolio_id, body } = payload
  try {
    const res = await axios.delete(
      `portfolio/portfolio-uploaded-files/${portfolio_id}/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: body,
      }
    );
    return res;
  } catch (err) {
    return err;
  }
};

export const downloadPortfolioFile = async (token, params) => {
  try {
    const res = await axios.get(`agency/daily-progress-export/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: params
    });
    return res;
  } catch (error) {
return error?.response?.data;
  }
}
export const downloadMontlyReport = async (token, params) => {
  try {
    const res = await axios.get(`agency/admin/monthly-ptp/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: params
    });
    return res;
  } catch (error) {
return error?.response?.data;
  }
}